export default __webpack_public_path__ + "static/media/logo-light.37cab23b.png";